import React from 'react';
import './Timeline.css';

const Timeline = ({ title, items = [] }) => {
  if (!items.length) return null;

  return (
    <div className="timeline">
      {title && <h3 className="timeline__title">{title}</h3>}
      <div className="timeline__track">
        {items.map((item, index) => (
          <div key={`${item.date}-${index}`} className="timeline__item">
            <div className="timeline__dot" />
            <div className="timeline__content">
              <span className="timeline__date">{item.date}</span>
              <h4>{item.title}</h4>
              {item.description && <p>{item.description}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
